import { Heading, Text } from "@sentricmusic/ui";
import { useTranslation } from "react-i18next";

import Spacer from "@/components/Spacer";

function ResetPasswordMessage() {
  const { t } = useTranslation();
  return (
    <div>
      <div className="container mx-auto">
        <div className="flex flex-col items-center justify-center min-h-screen-minus-footer p-4 text-center">
          <Heading as="h1" className="text-white">{t("auth:reset-thank-you")}</Heading>
          <div className="w-full lg:w-2/3 text-white">
            <Spacer />
            <Text as="bodyLg" className="text-white">{t("auth:reset-email-sent")}</Text>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ResetPasswordMessage;
